export default __webpack_public_path__ + "static/media/round-arrow.03446b8e.svg";